import React from 'react'
import { FieldProps } from '../FormDuuf'

const Label: React.FC<FieldProps> = ({ fieldId, data }) => {
  if (data.labelPlacement.toLowerCase() === 'hidden_label') {
    return null
  }

  return (
    <label className="form-duuf-label d-block mb-0" htmlFor={fieldId}>
      {data.label}
      {data.isRequired && <span className="form-duuf-label-mandatory">*</span>}
    </label>
  )
}

export default Label
